// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/produkte/welding-rings/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteWeldingRingsEN: PageEntry = {
  id: "example.produkte-schweissringe",
  locale: "en",
  slug: "produkte/welding-rings",
  seo: {
    title: "Welding rings | Dietz GmbH",
    description: "Gasket insert in the engine compartment of a car. Implementation of a flexible tool for a wide range of wire and ring diameters. Mass is an essential factor for component function.",
  },
  type: "post",
  h1: "Welding rings",
  intro: "Gasket insert in the engine compartment of a car. Implementation of a flexible tool for a wide range of wire and ring diameters. Mass is an essential factor for component function.",
  blocks: [
    { kind: "image", src: "/images/live/DTZ_schweissringe.jpg", alt: "Welding rings", width: 800, height: 640 }
  ],
};
